
const apiUrl = 'https://pro.lepton-seguridad.com/api-v2';

export const fetchUserAuth = async (email, password) => {
    try {
        const response = await fetch(`${apiUrl}/user/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                login: email,
                password: password
            }),
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Error al iniciar sesión.');
        }
    } catch (error) {
        throw new Error('Error al iniciar sesión.');
    }
};

export const fetchUserLogOut = async (userHash) => {
    try {
        const response = await fetch(`${apiUrl}/user/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hash: userHash
            }),
        });

        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Error al cerrar sesión.');
        }
    } catch (error) {
        throw new Error('Error al cerrar sesión.');
    }
};

export const fetchUserInfo = async (userHash) => {
    try {
        const response = await fetch(`${apiUrl}/user/get_info`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hash: userHash
            }),
        });

        if (response.ok) {
            return await response.json();
        } else {
            // console.log('Error al obtener los datos del usuario.');
            throw new Error('Error al obtener los datos del usuario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor.', error);
        throw new Error('Error al obtener los datos del usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchUserDevices = async (userHash) => {
    try {
        const response = await fetch(`${apiUrl}/tracker/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                sort: ["label=asc"],
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información de los dispositivos.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información de los dispositivos.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchGeoTags = async (userHash) => {
    try {
        const response = await fetch(`${apiUrl}/tag/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información de las etiquetas.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información de las etiquetas.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchGeofences = async (userHash) => {
    try {
        const response = await fetch(`${apiUrl}/zone/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                limit: 100,
                offset: 0,
                sort: ["label=asc"],
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información de las geocercas.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información de las geocercas.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchUnreadUserEventsCount = async (userHash, from) => {
    try {
        const response = await fetch(`${apiUrl}/history/unread/count`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                from
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener la cuenta de los eventos no leídos.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener la cuenta de los eventos no leídos.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchUnreadUserEventsList = async (userHash, events, from) => {
    try {
        const response = await fetch(`${apiUrl}/history/unread/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                from,
                events
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener la lista de los eventos no leídos.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener la lista de los eventos no leídos.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchUserEvents = async (userHash, events, from, to, limit = undefined) => {
    try {
        const response = await fetch(`${apiUrl}/history/user/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                from,
                to,
                ascending: false,
                events,
                limit,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información de las notificaciones.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información de las notificaciones.'); // Lanzar el error para manejarlo más arriba
    }
};

const MAX_RETRIES = 5; // Número máximo de reintentos permitido

export const fetchGenerateReport = async (userHash, data, retries = 0) => {
    try {

        const response = await fetch(`${apiUrl}/report/tracker/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                title: data.title,
                trackers: data.trackers,
                from: data.from,
                to: data.to,
                // geocoder: 'google',
                time_filter: { from: '00:00:00', to: '23:59:59', weekdays: [1, 2, 3, 4, 5, 6, 7] },
                plugin: data.plugin,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            const errorData = await response.json();
            if (errorData.status.code === 15) { // Código 15 para "Too Many Requests"
                if (retries < MAX_RETRIES) {
                    console.warn(`Reintento ${retries + 1} de ${MAX_RETRIES}: Demasiadas solicitudes. Obteniendo nuevo ID...`);
                    return await fetchNewReportId(userHash, data, retries + 1);
                } else {
                    throw new Error('Se alcanzó el máximo número de reintentos para generar el reporte.');
                }
            }
            const err = new Error('Error al obtener el reporte.');
            err.code = errorData.status.code;
            err.details = errorData;
            throw err;

        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw error;
    }
};

export const fetchNewReportId = async (userHash, data, retries = 0) => {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms)); // Función de espera

    try {
        const response = await fetch(`${apiUrl}/report/tracker/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash
            }),
        });

        if (response.ok) {
            const responseData = await response.json();

            // Filtrar la lista donde 'title' sea igual a la variable 'title' y 'percent' sea menor que 100
            const filteredList = responseData.list.filter(item => item.title === data.title && item.percent < 100);

            if (filteredList.length > 0) {
                return filteredList[0]; // Retorna el primer elemento que cumple las condiciones
            } else {
                if (retries < MAX_RETRIES) {
                    console.warn(`Reintento ${retries + 1} de ${MAX_RETRIES}: No se encontró ningún reporte. Intentando de nuevo en 5 segundos...`);
                    await delay(5000); // Espera 5 segundos
                    return await fetchGenerateReport(userHash, data, retries + 1); // Reintenta generar el reporte
                } else {
                    throw new Error('Se alcanzó el máximo número de reintentos para obtener el reporte.');
                }
            }
        } else {
            throw new Error('Error al obtener el nuevo ID de reporte.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw error;
    }
};

export const checkReportStatus = async (userHash, reportID, onReady) => {
    const statusResponse = await fetch(`${apiUrl}/report/tracker/status`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            hash: userHash,
            report_id: reportID,
        }),
    });

    const statusData = await statusResponse.json();
    if (statusResponse.ok) {
        if (statusData.percent_ready === 100) {
            onReady();
        } else {
            // Esperar un segundo antes de volver a consultar
            setTimeout(() => checkReportStatus(userHash, reportID, onReady), 1000);
        }
    } else {
        // console.error('Error al consultar el estado del reporte:', statusData);
        throw new Error();
    }
};

export const fetchRetrieveReport = async (userHash, reportID) => {
    try {
        if (!reportID) {
            throw new Error('El reportID no es válido.');
        }

        const response = await fetch(`${apiUrl}/report/tracker/retrieve`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                report_id: reportID
            }),
        });

        const data = await response.json();
        if (!response.ok) {
            if (data.code === 229) {
                // Puedes manejar el código 229 aquí si deseas
                return { success: false, code: 229, message: 'Requested data is not ready yet' };
            }
            throw new Error('Error al leer el reporte del día de hoy.');
        }
        return data;
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw error; // Lanzar el error para manejarlo más arriba
    }
};

export const deleteReport = async (userHash, reportId) => {
    try {
        const response = await fetch(`${apiUrl}/report/tracker/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                report_id: reportId
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al eliminar el reporte.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw error;
    }
};

export const fetchStatusColorUpdate = async (userHash, colors) => {
    try {
        const response = await fetch(`${apiUrl}/user/settings/ui/update`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                key: "tracker-icons",
                value: colors,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al actualizar los colores de los vehículos.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al actualizar los colores de los vehículos.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchOrientationReport = async (userHash, from, to, trackerId) => {
    try {
        const response = await fetch(`${apiUrl}/tracker/raw_data/read`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'text/csv'
            },
            body: JSON.stringify({
                hash: userHash,
                columns: ["heading"],
                from,
                to,
                tracker_id: trackerId
            }),
        });

        if (!response.ok) {
            throw new Error('Error al obtener orientación');
        }

        const csvText = await response.text();

        return csvText;

    } catch (error) {
        throw new Error('Error al obtener información de la orientación del vehículo');
    }
};


// ------------------------------------------------- LeptónCheck Api ----------------------------------------------

const apiLeptonCheckUrl = 'https://leptoncheck-api.lepton-seguridad.com';
// const apiLeptonCheckUrl = 'http://localhost:3103';

export const fetchApiGetUser = async (userHash) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users?hash=${userHash}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información del usuario.');
        }
         
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información del usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiGetUsers = async (userHash) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users/all?hash=${userHash}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener información del usuario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener información del usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiUserRegister = async (userHash, hash, expirationDate) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                userHash: hash,
                expirationDate
            }),
        });

        const data = await response.json();

        if (response.ok) {
            return data;
        } else {
            const error = new Error(data.error || 'Error al registrar el usuario.');
            error.status = response.status; // ← Aquí guardas el código
            error.data = data.data || null;
            throw error;
        }
    } catch (error) {
        // Si el error ya tiene un status (viene de fetch), lo dejamos así
        if (error.status) throw error;

        // Si es otro tipo de error (por ejemplo red de red o catch externo)
        const genericError = new Error('Error al registrar el usuario.');
        genericError.status = 500;
        throw genericError;
    }
};


export const fetchApiUpdateUserData = async (userHash, devices, geoTags, geofences) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users/new`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                vehicles: devices,
                geoTags,
                geofences
            }),
        });

        if (!response.ok) {
            const error = new Error('Error al actualizar la información del usuario.');
            error.status = response.status;
            throw error;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // Re-lanzamos el error con status si no tiene uno ya
        if (!error.status) {
            error.status = 500;
        }
        throw error;
    }
};


export const fetchApiUserUpdate = async (userHash, data) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                data
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al actualizar la información del usuario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al actualizar la información del usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiUserDelete = async (userHash, data) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/users`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                data
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al eliminar el usuario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al eliminar el usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiGetSchedules = async (userHash) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedules/all?hash=${userHash}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener los horarios.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener los horarios.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiUserSchedules = async (userHash) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedules?hash=${userHash}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener los horarios.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al obtener los horarios.'); // Lanzar el error para manejarlo más arriba
    }
};


export const fetchApiScheduleRegister = async (userHash, data) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedules`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                data
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al registrar horario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al registrar horario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiUpdateSchedule = async (userHash, data) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedules`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                data
            }),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al actualizar los horarios del usuario.');
        }
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);
        throw new Error('Error al actualizar los horarios del usuario.'); // Lanzar el error para manejarlo más arriba
    }
};

export const fetchApiDeleteSchedule = async (userHash, schedules) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedules`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                schedules // Pasar el array de horarios
            }),
        });

        if (!response.ok) {
            // Si la respuesta no es "ok", obtén el mensaje de error del servidor
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al eliminar horarios.');
        }

        // Analiza los datos de la respuesta
        const responseData = await response.json();
        return {
            success: true,
            message: responseData.message || 'Horarios eliminados con éxito.',
        };
    } catch (error) {
        // console.error('Error al conectar con el servidor:', error);

        // Retorna un objeto más detallado para manejar errores a nivel de cliente
        return {
            success: false,
            message: error.message || 'Error inesperado al eliminar horarios.',
        };
    }
};

export const fetchApiUserSchedulesGroups = async (userHash) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedulesGroups?hash=${userHash}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Error al obtener los grupos de horarios.');
        }
    } catch (error) {
        throw new Error('Error al obtener los grupos de horarios.');
    }
};

export const fetchApiSchedulesGroupsRegister = async (userHash, data) => {
    try {
        const response = await fetch(`${apiLeptonCheckUrl}/schedulesGroups`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                data
            }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "Error al registrar grupo.");
        }

        const result = await response.json();
        return result;

    } catch (error) {
        throw new Error(error.message || "Error al registrar grupo.");
    }
};

export const fetchApiSchedulesGroupsDelete = async (userHash, groups) => {

    try {

        const response = await fetch(`${apiLeptonCheckUrl}/schedulesGroups`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                hash: userHash,
                groups
            }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(
                error.message || "Error al eliminar grupo."
            );
        }

        const result = await response.json();
        return result;
    } catch (error) {
        throw new Error(
            error.message || "Error al eliminar grupo."
        );
    }

};

export const fetchApiSchedulesGroupsUpdate =
    async (userHash, data) => {

        const response = await fetch(
            `${apiLeptonCheckUrl}/schedulesGroups`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    hash: userHash,
                    data
                }),
            }
        );

        if (!response.ok) {
            const error = await response.json();
            throw new Error(
                error.message || "Error update"
            );
        }
        return await response.json();
    };
